import React from "react";
import { Link } from "react-router-dom";
import { Clock, Barbell } from "@phosphor-icons/react";
import { thumbUrl } from "../lib/api";

export default function ClassCard({ cls, span = "normal" }) {
  const spanCls = span === "wide" ? "md:col-span-2" : span === "tall" ? "md:row-span-2" : "";
  const isFree = !!cls.is_free;
  return (
    <Link
      to={`/classes/${cls.id}`}
      data-testid={`class-card-${cls.id}`}
      className={`card-tactical block group relative overflow-hidden ${spanCls}`}
    >
      <div className="relative aspect-video overflow-hidden bg-[#1F1812]">
        <img
          src={thumbUrl(cls.id)}
          alt={cls.title}
          className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
          onError={(e) => { e.target.style.display = "none"; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold bg-black/70 backdrop-blur-sm px-2 py-1 text-white">{cls.category}</span>
          {isFree && <span className="text-[10px] uppercase tracking-[0.2em] font-bold bg-[#D4A574] text-black px-2 py-1" data-testid="free-badge">Free</span>}
        </div>
        <div className="absolute bottom-3 right-3 flex items-center gap-3 text-xs text-white/90 drop-shadow">
          <span className="flex items-center gap-1"><Clock size={14} weight="bold" />{cls.duration_min}M</span>
          <span className="flex items-center gap-1"><Barbell size={14} weight="bold" />{cls.difficulty}</span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-display text-2xl tracking-wider leading-none mb-2 text-[#0F0A05] group-hover:text-[#7A4F1F] transition-colors">
          {cls.title}
        </h3>
        <div className="flex items-baseline justify-between mt-4">
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#3D2F22]">{isFree ? "Free Class" : "Unlock"}</span>
          {isFree ? (
            <span className="font-display text-xl text-[#0F0A05]">£0</span>
          ) : (
            <span className="font-display text-xl text-[#7A4F1F]">£{Number(cls.price ?? 4).toFixed(2)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
